import api from './axiosInstance';
import i18n from '../i18n';

export const registerPushToken = async (userId, pushToken) => {
    try {
        const response = await api.post('/register-push', { userId, pushToken });
        return response.data;
    } catch (error) {
        console.error('Error adding push token:', error);
        throw new Error(i18n.t('pushService.register_error'));
    }
};

export const togglePushPreferences = async (userId, isPushEnabled) => {
    try {
        const response = await api.post('/preferences/toggle-push', { userId, isPushEnabled });
        return response.data;
    } catch (error) {
        console.error('Error toggling push preference:', error);
        throw new Error(i18n.t('pushService.register_error'));
    }
};